import { useQuery } from "@tanstack/react-query";
import { getSimilarContent } from "../api/content.api";
import { ContentRow } from "../api/content.type";

type UseSimilarContentOptions = {
  enabled?: boolean;
};

export function useSimilarContent(
  contentId?: string,
  options?: UseSimilarContentOptions
) {
  const { enabled = true } = options ?? {};

  const { data: relatedContent, isLoading, isError, error } =
    useQuery<ContentRow[]>({
      queryKey: ["content", "similar", { contentId }],
      queryFn: () => getSimilarContent(contentId as string),
      enabled: enabled && !!contentId,
    });

  return { relatedContent, isLoading, isError, error };
}
